// CAPABILITY: Chat HTTP client (browser -> moderated Cloud Functions)
// Mirrors src/analytics/api/viewerAnalytics.js: resolves the deployed function
// URL from the Firebase project id, POSTs JSON, fails soft with structured logs.

import app from "../../firebase";

function getProjectId() {
  return app?.options?.projectId || process.env.REACT_APP_FIREBASE_PROJECT_ID || "";
}

function fnUrl(name, override) {
  if (override) return override;
  const projectId = getProjectId();
  return projectId ? `https://us-central1-${projectId}.cloudfunctions.net/${name}` : "";
}

export function getPostChatMessageUrl() {
  return fnUrl("postChatMessage", process.env.REACT_APP_CHAT_POST_URL);
}

export function getSetChatDisplayNameUrl() {
  return fnUrl("setChatDisplayName", process.env.REACT_APP_CHAT_NAME_URL);
}

async function postJson(url, payload, label) {
  if (!url) {
    console.warn("CHAT_REQUEST_DISABLED", `label=${label} reason=missing_url`);
    return { ok: false, disabled: true };
  }
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "omit",
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      console.warn("CHAT_REQUEST_FAILED", `label=${label} status=${response.status} code=${data?.reason_code || "unknown"}`);
      return { ok: false, status: response.status, ...data };
    }
    return { ok: true, ...data };
  } catch (error) {
    console.warn("CHAT_REQUEST_ERROR", `label=${label} code=${error?.name || "unknown"}`);
    return { ok: false, error };
  }
}

export async function sendChatMessage({ pageId, viewerId, displayName, text }) {
  const result = await postJson(
    getPostChatMessageUrl(),
    { pageId, viewerId, displayName, text },
    "post_message"
  );
  console.info(
    result.ok ? "CHAT_MESSAGE_SENT" : "CHAT_MESSAGE_SEND_FAILED",
    `page_id=${pageId} viewer_id=${viewerId || "unknown"} status=${result.status_label || result.status || "n/a"}`
  );
  return result;
}

export async function setChatDisplayName({ pageId, viewerId, name }) {
  const result = await postJson(
    getSetChatDisplayNameUrl(),
    { pageId, viewerId, name },
    "set_name"
  );
  console.info(
    result.ok ? "CHAT_NAME_SET" : "CHAT_NAME_SET_FAILED",
    `page_id=${pageId} viewer_id=${viewerId || "unknown"} name_status=${result.name_status || "n/a"}`
  );
  return result;
}
